export const pageTitle = (title) => {
    return ( document.title = title + " - IT Solutions & Technology");
  }